import { AxiosResponse } from 'axios';
import {
  DataDeclarationVM,
  DataDeclarationIcaro,
  FormDeclarationIcaroVM,
  SubjectIcaroVM,
} from 'civil-status/view-models/form-declaration-icaro';
import { HttpResponse } from 'shell/models/http-response';
import { transformerDataDeclaration } from './transformer-data-declaration';
import { transformerFather } from './transformer-father';
import { transformerMother } from './transformer-mother';
import { transformerDeclarant } from './transformer-declarant';
import { transformerBorn } from './transformer-born';

export const transformerDeclarationIcaro = (
  response?: AxiosResponse<HttpResponse<DataDeclarationIcaro>>
): FormDeclarationIcaroVM => {
  const data = response?.data?.payload || {};

  const dataDeclaration: DataDeclarationVM | undefined = transformerDataDeclaration(data);
  const father: SubjectIcaroVM | undefined = transformerFather(data);
  const mother: SubjectIcaroVM | undefined = transformerMother(data);
  const declarant: SubjectIcaroVM | undefined = transformerDeclarant(data);
  const born: SubjectIcaroVM | undefined = transformerBorn(data);

  return {
    dataDeclaration,
    father,
    mother,
    declarant,
    born,
  };
};
